// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  touch-action: none;
}

.palette button {
  width: 40px;
  height: 40px;
  margin: 0 5px;
  border: 2px solid #333;
  cursor: pointer;
}

 .palette button.selected {
  border: 4px solid black;
}
.grid {
  display: grid;
  grid-template-columns: repeat(200, 60px);
  justify-content: center;
}

.tile {
  width: 60px;
  height: 60px;
  border: 1px solid #333;
  cursor: pointer;
}

.panzoom-container {
  width: 100%;
  height: 80vh;
  overflow: hidden;
  border: 1px solid #444;
  position: relative;
}

.panzoom-inner {
  transform-origin: top left;
  cursor: grab;
}

.panzoom-inner.dragging {
  cursor: grabbing;
}

.header {
  height:150px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;CAEC;EACC,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".App {\n  text-align: center;\n  touch-action: none;\n}\n\n.palette button {\n  width: 40px;\n  height: 40px;\n  margin: 0 5px;\n  border: 2px solid #333;\n  cursor: pointer;\n}\n\n .palette button.selected {\n  border: 4px solid black;\n}\n.grid {\n  display: grid;\n  grid-template-columns: repeat(200, 60px);\n  justify-content: center;\n}\n\n.tile {\n  width: 60px;\n  height: 60px;\n  border: 1px solid #333;\n  cursor: pointer;\n}\n\n.panzoom-container {\n  width: 100%;\n  height: 80vh;\n  overflow: hidden;\n  border: 1px solid #444;\n  position: relative;\n}\n\n.panzoom-inner {\n  transform-origin: top left;\n  cursor: grab;\n}\n\n.panzoom-inner.dragging {\n  cursor: grabbing;\n}\n\n.header {\n  height:150px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
